import clsx from 'clsx';
import type React from 'react';
import { type Control, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { WEEK_DAYS_SHORT } from '../../Calendar.constants';
import type { FormDataIntervals } from '../../Calendar.types';

interface Props {
  name: 'weekDays';
  control: Control<FormDataIntervals>;
}

export const MultipleDaySelector: React.FC<Props> = ({ name, control }) => {
  const { t } = useTranslation();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value } }) => (
        <div className='flex flex-wrap gap-y-1'>
          {WEEK_DAYS_SHORT.map((weekDay: string, index: number) => {
            const isSelected = value?.includes(weekDay);
            const day: number = index + 1;
            const className = clsx(
              'px-3 py-2 text-gray-500 text-sm font-normal flex-auto border-r max-w-[105px]',
              {
                'bg-success text-white': isSelected,
                'bg-gray-200': !isSelected,
                'border-r border-gray-200': index < WEEK_DAYS_SHORT.length - 1,
              },
            );

            return (
              <button
                type='button'
                id={`tbg-btn-${weekDay}`}
                key={weekDay}
                className={className}
                onClick={() => {
                  if (!value) {
                    return;
                  }

                  if (isSelected) {
                    onChange(value.filter((val: string) => val !== weekDay));
                  } else {
                    onChange([...value, weekDay]);
                  }
                }}>
                {t(`timetable.weekdays.${day}`)}
              </button>
            );
          })}
        </div>
      )}
    />
  );
};

export default MultipleDaySelector;
